import { render, staticRenderFns } from "./Followings.vue?vue&type=template&id=30b22552&scoped=true&"
import script from "./Followings.vue?vue&type=script&lang=js&"
export * from "./Followings.vue?vue&type=script&lang=js&"
import style0 from "./Followings.vue?vue&type=style&index=0&id=30b22552&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b22552",
  null
  
)

export default component.exports